<template>
    <div class="wrapper py-6 px-1 md:px-2 lg:px-6">
        <div>
            <div class="mx-auto py-8 max-w-sm flex justify-center text-black">
                <AppLogo class="h-8"/>
            </div>

            <slot/>
        </div>
        <p class="copy">For more info and inquiries contact us at <a href="mailto:eventhos@eventhos.com">eventhos@eventhos.com</a></p>
    </div>
</template>

<script>
export default {
    name: 'Auth',
}
</script>
<style>
.wrapper{
    display:flex;
    flex-direction:column;
    justify-content:center;
    align-items:center;
    min-height:100vh;
    min-height:100dvh;
}
.copy{
    margin-top: auto;
    padding-top: 2rem;
}
</style>
